import {
	TDatesFilter,
	TOverviewPeriod,
	TProjectSummary,
	TTasksFilters,
	TView,
	TViewOverview,
	TViewPayload,
	TViewSummary,
} from "@/types";

import API from "./api";

/**
 * Views: what replaces the views. A view selects projects and
 * clients; everything it answers — its projects, their figures, the
 * tasks — is those projects (docs/modele.md, phase 6).
 */
class ViewsClass {
	getViews = (): Promise<TView[]> => {
		return API.get("views").then((res) => res.data);
	};

	/** The list page's rows; `period` empty = the current month, server side. */
	getViewsSummary = (period: TDatesFilter = {}): Promise<TViewSummary[]> => {
		return API.get("views/summary", { params: period }).then(
			(res) => res.data
		);
	};

	getViewProjects = (id: number) => {
		return API.get(`views/${id}/projects`).then((res) => res.data);
	};

	getViewProjectsSummary = (
		id: number,
		period: TDatesFilter = {}
	): Promise<TProjectSummary[]> => {
		return API.get(`views/${id}/projects/summary`, {
			params: period,
		}).then((res) => res.data);
	};

	getViewTasks = (id: number, filters: TTasksFilters) => {
		return API.post(`views/${id}/tasks`, filters).then((res) => res.data);
	};

	getView = (id: number): Promise<TView> => {
		return API.get(`views/${id}`).then((res) => res.data);
	};

	createView = (view: TViewPayload): Promise<TView> => {
		return API.post("views", view).then((res) => res.data);
	};

	updateView = (id: number, view: TViewPayload): Promise<TView> => {
		return API.put(`views/${id}`, view).then((res) => res.data);
	};

	/** Replaces what the view selects; a client brings its projects, present and future. */
	setSelection = (
		id: number,
		selection: { projects?: number[]; clients?: number[] }
	): Promise<TView> => {
		return API.put(`views/${id}/selection`, selection).then(
			(res) => res.data
		);
	};

	deleteView = (id: number) => {
		return API.delete(`views/${id}`).then((res) => res.data);
	};

	setViewArchived = (id: number, archived: boolean) => {
		return API.patch(`views/${id}/archive`, { archived }).then(
			(res) => res.data
		);
	};

	/** The view page's figures at once; `period` empty = the current month. */
	getOverview = (
		id: number,
		period: TOverviewPeriod = {}
	): Promise<TViewOverview> => {
		return API.get(`views/${id}/overview`, { params: period }).then(
			(res) => res.data
		);
	};
}

const ViewsService = new ViewsClass();
export default ViewsService;
